import { app } from '../../../../../../app';
import { Controller } from './bulk-verification.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryBulkVerification', {
    bindings: {
        companyId: '<',
        directoryId: '<',
    },
    controller: Controller,
    templateUrl: require('./bulk-verification.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification/bulk-verification.component.js